import { MutationTree, GetterTree } from 'vuex'
import { SET_ALERT_CONTENT } from '../types'
import { RootState } from '..'

export interface AlertState {
    isAlert: boolean;
    alertContent: string;
}


const state: AlertState = {
    isAlert: false,
    alertContent: '',
}


const getters: GetterTree<AlertState, RootState> = {
    isAlert: (state) => state.isAlert,
    alertContent: (state) => state.alertContent,
}

const mutations: MutationTree<AlertState> = {
    async [SET_ALERT_CONTENT](state, content: string) {
        state.isAlert = true
        state.alertContent = content
        window.scrollTo(0, 0)
        await new Promise((resolve) => setTimeout(resolve, 3000))
        state.isAlert = false

    },

}


export default {
    state,
    getters,
    mutations,
}
